import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';
import { useUser } from '@/store/user';

export const useComponentStatuses = defineStore('component-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.componentStatus_ListComponentStatuses,
    dto: 'ComponentStatusDto',
    create: api.componentStatus_CreateComponentStatus,
    update: api.componentStatus_UpdateComponentStatus,
    delete: api.componentStatus_DeleteComponentStatus,
    usage: api.componentStatus_GetUsage,
    signalR: 'ComponentStatusUpdate',
  });

  async function replace(id: number, replacementId: number) {
    await api.componentStatus_Replace(useUser().brandId, id, { replacementId });
    await globalStoreBase.loadAll();
  }

  return {
    ...globalStoreBase,
    replace,
  };
});
